<template lang="pug">
  ods-dialog(
    v-if='$parent.chartModal'
    :visible.sync='$parent.chartModal'
    width='95%'
    :append-to-body='true'
    custom-class='sc-modal zChartKpiModal'
  )
    Card(:scrollbar="false" :loading='!!!loading').dialog
      template(slot="header")
        div.card-title {{ $t(title) }}
          span.unitChart(v-if='unit != ""') ({{ $t(unit) }})
      div.sc-modal__body.chartKpiData(v-if="$parent.chartModal")
        ods-row
          ods-col(:span='24')
            StatusCero(
              v-if='!data'
              title='no data'
              description='no data kpi chart suficient'
            )
            template(v-else)
              ods-scrollbar(wrap-class='ods-scrollbar__wrap')
                div(class='m7d')
                  //- Chart(:dataChart='data')
                  PluginZoomChart(:dataChart='data')
</template>

<script>
import Card from '@/components/Card'
import StatusCero from '@/components/StatusCero'
import mapElements from '@/mixins/mapElements'
import mapChartsElements from '@/mixins/mapChartsElements'
import Chart from '@/components/Chart'
import PluginZoomChart from '@/components/PluginZoomChart'
export default {
  name: 'ChartModal',
  data () {
    return {

    }
  },
  props: {
    title: {
      type: String,
      default: 'Tipo'
    },
    unit: {
      type: String,
      default: 'Unidad'
    },
    data: {
      type: Object
    },
    visibilidad: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean
    }
  },
  mixins: [ mapElements, mapChartsElements ],
  components: {
    Card,
    StatusCero,
    Chart,
    PluginZoomChart
  }
}
</script>

<style lang="scss" scoped>

/deep/ .zChartKpiModal{
  &.ods-dialog{
    &.sc-modal{
      max-width: 60%;
      .dialog{
        .chartKpiData{
          padding: 0 !important;
        }
        .sc-card__header {
          padding-left: 0;
          padding-right: 0;
        }
      }
      /deep/ .ods-scrollbar__wrap{
        max-height: inherit;
        .ods-scrollbar__view{
          height: 100%;
        }
      }
      .sc-modal__body{
        padding: rem(62) rem(20) 0;
        margin-top: 0;
        width: 100%;
        background-color: $--color-white;
      }
    }
  }
  .card-title{
    text-transform: uppercase;
  }
  .unitChart {
    margin-left: rem(8);
  }
  /deep/ .ct-chart .ct-chart-line .ct-label.ct-horizontal.ct-end {
    transform: rotate(-21deg) translateY(-44%) translateX(-38%);
    width: 60px !important;
  }
}
/*
.m7d {
  padding-bottom: rem(16);
  padding-right: rem(32);
  width: 7000px;
    height: 17.5rem;
    overflow-y: hidden;
  .environment-and-meteorology__chart__size{
    width: 7000px;
  }
}
*/
</style>



// WEBPACK FOOTER //
// src/components/ChartModal.vue